/**
 * An account suspended while its deletion waits. The rule lives in the API
 * (apps/api/src/app/users/domain/a-suspended-account.ts, decided by Maude on
 * 22/10/2026); this file only names what the back-office shows of it.
 *
 * Kept here rather than in the generated SDK: the SDK is regenerated from a
 * running API, and these fields are newer than its last regeneration.
 */
export type AccountSuspensionReason = 'minor' | 'other';

export const ACCOUNT_SUSPENSION_REASONS: readonly AccountSuspensionReason[] = ['minor', 'other'];

export interface AccountSuspension {
  at: string;
  reason: AccountSuspensionReason;
}

/** The label the drawer shows next to the « suspended » badge. */
export const suspensionReasonLabelKey = (reason: AccountSuspensionReason): string =>
  reason === 'minor' ? 'userDetail.suspendedReasonMinor' : 'userDetail.suspendedReasonOther';

/** The label of each choice in the « unable to delete » dialog. */
export const suspensionReasonChoiceKey = (reason: AccountSuspensionReason): string =>
  reason === 'minor' ? 'dialogs.suspendReasonMinor' : 'dialogs.suspendReasonOther';
